import { render, staticRenderFns } from "./recommendNews.vue?vue&type=template&id=095bdb55&scoped=true&"
import script from "./recommendNews.vue?vue&type=script&lang=js&"
export * from "./recommendNews.vue?vue&type=script&lang=js&"
import style0 from "./recommendNews.vue?vue&type=style&index=0&id=095bdb55&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095bdb55",
  null
  
)

export default component.exports